import { Link } from "react-router-dom";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <nav className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#0F2557] font-bold text-lg">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line text-base"></i>
            </div>
            Wróć na stronę główną
          </Link>
          <span className="text-xs text-gray-400">Ostatnia aktualizacja: 03.04.2026</span>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-14 lg:py-20">
        <header className="mb-12">
          <span className="inline-block text-[#0F2557] text-sm font-semibold tracking-wide uppercase mb-3">Dokument prawny</span>
          <h1 className="text-4xl font-bold text-[#1A1A2E] mb-4">Regulamin świadczenia usług</h1>
          <p className="text-gray-500 text-lg">Niniejszy Regulamin określa zasady świadczenia usług tworzenia stron internetowych oraz warunki współpracy między Usługodawcą a Klientem.</p>
        </header>

        <div className="prose max-w-none text-gray-600 leading-relaxed space-y-10">

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§1. Definicje</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-[#1A1A2E]">Usługodawca</strong> — Tomasz Kowalski, świadczący usługi tworzenia stron internetowych dla firm usługowych.</li>
              <li><strong className="text-[#1A1A2E]">Klient</strong> — osoba fizyczna prowadząca działalność gospodarczą lub osoba prawna, która zamawia usługi.</li>
              <li><strong className="text-[#1A1A2E]">Usługa</strong> — tworzenie, utrzymanie i optymalizacja stron internetowych w modelu abonamentowym lub jednorazowym.</li>
              <li><strong className="text-[#1A1A2E]">Abonament</strong> — miesięczna opłata za korzystanie z usług zgodnie z wybranym pakietem.</li>
              <li><strong className="text-[#1A1A2E]">Panel CRM</strong> — system zarządzania leadami dostępny w pakiecie Firma i Pro.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§2. Zakres usług</h2>
            <p className="mb-3">Usługodawca świadczy następujące usługi w ramach pakietów abonamentowych:</p>
            <div className="grid sm:grid-cols-3 gap-4">
              {[
                { name: "Start", price: "299 zł/mies", items: ["Strona www (do 5 sekcji)", "Formularz kontaktowy", "SEO lokalne podstawowe", "Podpięcie domeny", "Hosting + aktualizacje", "Mobile 100%"] },
                { name: "Firma", price: "499 zł/mies", items: ["Wszystko z pakietu Start", "Panel CRM z historią leadów", "Automatyzacja FB/IG", "Kalkulator / konfigurator", "Generowanie ofert PDF", "SEO lokalne rozbudowane"] },
                { name: "Pro", price: "899 zł/mies", items: ["Wszystko z pakietu Firma", "Wizualizator 3D produktu", "Social media (2 posty/tyg)", "Montaż video / reels", "Priorytetowe wsparcie", "Raport miesięczny"] },
              ].map((pkg) => (
                <div key={pkg.name} className="bg-[#F7F8FA] rounded-lg p-4">
                  <h3 className="font-bold text-[#1A1A2E] mb-1">{pkg.name}</h3>
                  <p className="text-[#0F2557] font-semibold text-sm mb-3">{pkg.price}</p>
                  <ul className="space-y-1">
                    {pkg.items.map((item) => (
                      <li key={item} className="text-xs text-gray-500 flex items-start gap-1.5">
                        <i className="ri-check-line text-[#0F2557] text-xs mt-0.5 flex-shrink-0"></i>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§3. Zawarcie umowy</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Umowa zostaje zawarta po akceptacji oferty przez Klienta i uiszczeniu pierwszej opłaty abonamentowej.</li>
              <li>Przed zawarciem umowy Usługodawca przeprowadza bezpłatną konsultację (do 15 minut) w celu ustalenia zakresu usług.</li>
              <li>Szczegółowy zakres usług określa indywidualna oferta przesłana Klientowi drogą elektroniczną.</li>
              <li>Klient zobowiązany jest do dostarczenia niezbędnych materiałów (logo, zdjęcia, treści) w terminie uzgodnionym z Usługodawcą.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§4. Płatności i abonament</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Opłata abonamentowa jest pobierana miesięcznie z góry, do 5. dnia każdego miesiąca.</li>
              <li>Pierwsza opłata obejmuje uruchomienie strony i pierwszy miesiąc abonamentu.</li>
              <li>W przypadku braku płatności w terminie, Usługodawca ma prawo zawiesić świadczenie usług po uprzednim powiadomieniu Klienta.</li>
              <li>Ceny podane są w złotych polskich (PLN) i zawierają podatek VAT (jeśli dotyczy).</li>
              <li>Usługodawca zastrzega sobie prawo do zmiany cennika z zachowaniem 30-dniowego okresu wypowiedzenia.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§5. Czas realizacji</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Standardowy czas realizacji strony internetowej wynosi 3–5 dni roboczych od dostarczenia wszystkich materiałów przez Klienta.</li>
              <li>Termin może ulec wydłużeniu w przypadku opóźnień w dostarczeniu materiałów przez Klienta.</li>
              <li>Klient ma prawo do 2 rund poprawek w ramach uzgodnionego zakresu projektu.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§6. Własność i prawa autorskie</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>W modelu abonamentowym Usługodawca pozostaje właścicielem kodu źródłowego strony przez cały okres trwania umowy.</li>
              <li>Klient nabywa prawo do korzystania ze strony na czas trwania abonamentu.</li>
              <li>W przypadku wykupu kodu (opcja jednorazowa: 2 000–5 000 zł), Klient nabywa pełne prawa do kodu źródłowego po uiszczeniu opłaty.</li>
              <li>Materiały dostarczone przez Klienta (logo, zdjęcia, treści) pozostają własnością Klienta.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§7. Wypowiedzenie umowy</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Każda ze stron może wypowiedzieć umowę z zachowaniem 30-dniowego okresu wypowiedzenia.</li>
              <li>Wypowiedzenie następuje drogą elektroniczną na adres: <a href="mailto:tomasz.kdp@gmail.com" className="text-[#0F2557] hover:underline">tomasz.kdp@gmail.com</a></li>
              <li>Po zakończeniu umowy strona zostaje wyłączona, chyba że Klient wykupił kod źródłowy.</li>
              <li>Opłaty uiszczone za bieżący okres rozliczeniowy nie podlegają zwrotowi.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§8. Odpowiedzialność</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Usługodawca nie ponosi odpowiedzialności za treści publikowane przez Klienta na stronie.</li>
              <li>Usługodawca nie gwarantuje osiągnięcia określonej pozycji w wynikach wyszukiwania Google.</li>
              <li>Usługodawca dokłada wszelkich starań, aby strona była dostępna 24/7, jednak nie gwarantuje 100% dostępności.</li>
              <li>Odpowiedzialność Usługodawcy ograniczona jest do wysokości miesięcznego abonamentu.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§9. Postanowienia końcowe</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy Kodeksu Cywilnego.</li>
              <li>Wszelkie spory będą rozstrzygane polubownie, a w przypadku braku porozumienia — przez sąd właściwy dla siedziby Usługodawcy.</li>
              <li>Usługodawca zastrzega sobie prawo do zmiany Regulaminu z zachowaniem 14-dniowego okresu powiadomienia.</li>
              <li>Regulamin wchodzi w życie z dniem 03.04.2026.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">§10. Kontakt</h2>
            <div className="bg-[#F7F8FA] rounded-lg p-5 space-y-2">
              <p className="text-sm"><strong className="text-[#1A1A2E]">E-mail:</strong> <a href="mailto:tomasz.kdp@gmail.com" className="text-[#0F2557] hover:underline">tomasz.kdp@gmail.com</a></p>
              <p className="text-sm"><strong className="text-[#1A1A2E]">Telefon:</strong> <a href="tel:+48509963499" className="text-[#0F2557] hover:underline">+48 509 963 499</a></p>
            </div>
          </section>

        </div>
      </main>

      <footer className="border-t border-gray-100 py-8 mt-10">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">&copy; {new Date().getFullYear()} Strony www dla firm usługowych. Wszelkie prawa zastrzeżone.</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/polityka-prywatnosci" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Polityka prywatności</Link>
            <Link to="/rodo" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">RODO</Link>
            <Link to="/regulamin" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Regulamin</Link>
            <Link to="/polityka-cookies" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Cookies</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
